export const PLAID_LINK_ERROR_CODES = [
    'RATE_LIMIT',
    'INSTITUTION_DOWN',
    'INSTITUTION_NOT_RESPONDING',
    'INSTITUTION_NO_LONGER_SUPPORTED',
    'INVALID_CREDENTIALS',
    'INVALID_MFA',
    'ITEM_LOCKED',
    'USER_SETUP_REQUIRED',
    'TOO_MANY_VERIFICATION_ATTEMPTS',
    'INTERNAL_SERVER_ERROR'
];
export const UNKNOWN_PLAID_LINK_ERROR_CODE = 'UNKNOWN';
export var PaymentMethodAddStalledOutcome = /*#__PURE__*/ function(PaymentMethodAddStalledOutcome) {
    PaymentMethodAddStalledOutcome["Rescued"] = "rescued";
    PaymentMethodAddStalledOutcome["GaveUp"] = "gaveUp";
    return PaymentMethodAddStalledOutcome;
}({});
export const IDENTITY_MISMATCH_RELOAD_TRIGGERS = [
    'pageRestored',
    'becameVisible'
];
export const UNKNOWN_IDENTITY_MISMATCH_RELOAD_TRIGGER = 'unknown';
export const NOTIFICATION_PAYLOAD_KINDS = [
    'emptyString',
    'notAnObject',
    'missingNotificationType',
    'typedButUnrouted'
];
export const UNKNOWN_NOTIFICATION_PAYLOAD_KIND = 'unknown';
export const NOTIFICATION_ROUTER_ERRORS = [
    'unrecognizedNotification',
    'incorrectPayload'
];
export const UNKNOWN_NOTIFICATION_ROUTER_ERROR = 'unknown';
export const NOTIFICATION_VISIBILITY_STATES = [
    'visible',
    'hidden'
];
export const UNKNOWN_NOTIFICATION_VISIBILITY_STATE = 'unknown';
export const DEMO_BOOKING_FAILURE_KINDS = [
    'embedScriptError',
    'embedLoadTimeout',
    'hubspotSubmitFailed'
];
export const UNKNOWN_DEMO_BOOKING_FAILURE_KIND = 'unknown';
